@import "@/scss/use-bootstrap-mixins.scss";

.form {
  .field {
    // margin-bottom: 20px;

    .title {
      display: flex;
      align-items: center;
      gap: 12px;

      span.header_text {
        color: $primaryOnBackground !important;
        margin: 0 !important;
        font-size: calc(1.3rem + 0.6vw);
        font-weight: 600 !important;
      }

      .popover {
        path {
          fill: $primaryOnBackground !important;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }

    span.subtitle {
      display: block;
      font-size: 12px;
      font-style: italic;
      p {
        margin: initial;
        max-width: initial;
      }
      a {
        color: #337ab7 !important;
      }
    }
  }

  .insurance_picker {
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    min-height: 120px;
    padding: 20px;
    justify-content: space-between;

    div:nth-of-type(1),
    div:nth-of-type(3) {
      button {
        width: 40px !important;
        height: 40px !important;
        padding: 0;
        border-radius: 20px;
        background-color: #d9d9d9;
        border: 1px solid #d0d0d0;
        line-height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: #d0d0d0;
        }

        &:active {
          background-color: #c0c0c0;
        }

        &:disabled {
          opacity: 0.2;
        }

        svg {
          width: 20px;
          height: 20px;
          fill: #000;
        }
      }
    }

    div:nth-of-type(2) {
      .coverage {
        font-size: 16px;
        font-weight: 600;
        text-align: center;

        @include media-breakpoint-up(lg) {
          font-size: 30px;
        }
      }

      .total_coverage {
        font-size: 14px;
        display: block;
        text-align: center !important;
      }
    }
  }

  .insurance_boxes {
    display: flex;
    flex-direction: column;
    gap: 6px;

    @include media-breakpoint-up(lg) {
      gap: 12px;
    }

    .box {
      background-color: #fff;
      border: 1px solid #d0d0d0;
      border-radius: 4px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      gap: 6px;

      @include media-breakpoint-up(lg) {
        flex-direction: row;
        padding: 20px;
        gap: 12px;
      }

      .left {
        display: flex;
        gap: 12px;
        flex-basis: 65%;

        .first {
          flex-basis: 2%;
          display: flex;

          .checkbox {
            width: 20px;
            height: 20px;
            accent-color: $primary !important;
          }
        }

        .second {
          flex-basis: 98%;

          .header {
            display: block;
            font-size: 20px !important;
            font-weight: 600 !important;
            line-height: 1 !important;
            color: #333 !important;
            margin-bottom: 12px;
          }

          .subtitle {
            display: block;
            font-size: 12px !important;

            @include media-breakpoint-up(lg) {
              font-size: 14px !important;
            }
          }

          .disclaimer {
            display: block;
            font-size: 12px !important;

            @include media-breakpoint-up(lg) {
              font-size: 14px !important;
            }
          }
        }
      }

      .right {
        flex-basis: 35%;

        @include media-breakpoint-up(lg) {
          text-align: right;
        }

        .selectedCoverage {
          display: flex;
          align-items: center;
          gap: 6px;

          @include media-breakpoint-up(lg) {
            justify-content: end;
          }

          .bold {
            font-size: 20px !important;
            font-weight: 600 !important;
          }

          .normal {
            font-size: 16px !important;
          }
        }

        .subtitle {
          font-size: 12px !important;
          line-height: 16px !important;
          display: block;
          font-style: italic;
        }
      }
    }
  }

  .manualEntry {
    margin-top: 12px;

    .label {
      font-size: 16px;
      display: block;
    }

    .input_group {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .prefix {
        background-attachment: white;
        border-left: 1px solid #d0d0d0;
        border-top: 1px solid #d0d0d0;
        border-bottom: 1px solid #d0d0d0;
        padding: 0 6px;
        line-height: 36px !important;
        font-size: 20px !important;
        height: 40px !important;
        border-radius: 4px 0 0 4px;
        background-color: #ffffff;
        color: #444 !important;
      }

      .input {
        width: 100%;
        height: 40px !important;
        border: 1px solid #d0d0d0;
        border-radius: 0 4px 4px 0px;
        padding: 0 6px;
      }
    }
  }

  .modal {
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: scroll;
    background-color: rgba(0, 0, 0, 0.5);

    @include media-breakpoint-up(md) {
      overflow: hidden;
    }

    .dialog {
      position: absolute;
      bottom: 12px;
      left: 12px;
      right: 12px;
      top: 12px;
      background-color: #fff;
      border: 1px solid #888;
      max-width: 600px;
      padding: 12px;
      border-radius: 12px;
      position: fixed;
      max-height: 80vh;
      font-size: 14px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 12px;

      @include media-breakpoint-up(md) {
        position: relative;
        max-width: 600px;
        margin: 5% auto;
      }

      .body {
        font-size: 12px !important;
        overflow-y: scroll;
      }
    }
  }

  .open {
    display: block;
  }

  .closed {
    display: none;
  }
}
